<template>
	<nav id="menu"><div class="inner">
		<h2></h2>
		<ul>
			<li><router-link to="/">Übersicht</router-link></li>
			<li><router-link to="/eintragen">Unternehmen eintragen</router-link></li>
			<li><router-link to="/about">Unterstützung</router-link></li>
		</ul>
	</div><a class="close" href="#menu">Schließen</a>
	</nav>   
</template>

<script>

export default {
  name: 'RTNavigation',
  components:{
  },
  data: function() {
    return {
    };
  },
  methods:{
  }
};
</script>

<style scoped type='text/css'>

</style>